import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { deleteListingFromCart } from "../actions/cart";
import CartListingCard from "./CartListingCard";

const defaultErrorStateCart = {
  name: "",
  price: "",
  quantity: "",
  total: "",
};

const Cart = ({ cart }) => {
  return (
    <div>
      <Title>My Cart</Title>
      {cart.map((listing) => (
        <CartListingCard key={listing.id} listing={listing} />
      ))}
      <div className='itemsTotal'>
        <h2>Items Total</h2>
        <h3>ADD LISTINGS TOTAL HERE</h3>
        <h3>+Total</h3>
        <h3>100</h3>
        <form>
          <Link to='/checkout'>
            <button dat-cy='Checkout'>Checkout</button>
          </Link>
        </form>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  cart: state.cart.cart,
});

export default connect(mapStateToProps, { deleteListingFromCart })(Cart);

const Title = styled.h1`
  font-size: 3rem;
  text-align: center;
`;
